import { forwardRef, type SVGProps } from 'react';

export type FigmaMinusIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const FigmaMinusIcon = forwardRef<SVGSVGElement, FigmaMinusIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path clipRule="evenodd" d="M13.5 8.5H2.5V7.5H13.5V8.5Z" fill="currentColor" fillRule="evenodd" />
  </svg>
));

FigmaMinusIcon.displayName = 'FigmaMinusIcon';
